import React from 'react'
import { Button, Modal, Section } from '../../../components'

const ModalTimeOut = ({ timeOut, props, handlersClose, apiRedirectPath }) => {
  return (
    <Modal className={`theme-blue modals-time-out`} isOpen={timeOut}>
      <Modal.Header>Auction Closed</Modal.Header>
      <Modal.Body>
        <Section className="body-content-warning row">
          <Section className="text-detail-wrapper">
            <label>The auction event is closed</label>
          </Section>
        </Section>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="theme-gray"
          onClick={() => {
            props.history.replace(apiRedirectPath)
            handlersClose()
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalTimeOut
